import { Component, ElementRef, ViewChild } from '@angular/core';
import { IDateAngularComp } from 'ag-grid-angular';
import { IDateParams } from 'ag-grid-community';
import moment from 'moment';

import 'moment/locale/de';

@Component({
  selector: 'app-ag-grid-date',
  template: `
    <div class="ag-custom-date">
      <input
        [value]="displayValue"
        [placeholder]="placeholder"
        [disabled]="disabled"
        [attr.aria-label]="ariaLabel"
        (input)="onTextInput($event)"
        (keydown.enter)="onTextInput($event)"
        class="ag-input-field-input ag-text-field-input"
        type="text"
        #textInput />
      <input
        (change)="onNativeDateChange($event)"
        class="ag-custom-date-hidden-picker"
        type="date"
        #nativePicker
        tabindex="-1" />
      <button
        [disabled]="disabled"
        (click)="openCalendar()"
        class="ag-custom-date-calendar-btn"
        type="button"
        tabindex="-1">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
          <line x1="16" y1="2" x2="16" y2="6" />
          <line x1="8" y1="2" x2="8" y2="6" />
          <line x1="3" y1="10" x2="21" y2="10" />
        </svg>
      </button>
    </div>
  `,
  styles: [
    `
      .ag-custom-date {
        display: flex;
        align-items: center;
        width: 100%;
        height: 100%;
      }
      .ag-custom-date input[type='text'] {
        flex: 1;
        min-width: 0;
      }
      .ag-custom-date-hidden-picker {
        position: absolute;
        width: 0;
        height: 0;
        opacity: 0;
        overflow: hidden;
      }
      .ag-custom-date-calendar-btn {
        background: none;
        border: none;
        cursor: pointer;
        padding: 0 2px;
        display: flex;
        align-items: center;
        color: inherit;
      }
      .ag-custom-date-calendar-btn:disabled {
        cursor: default;
        opacity: 0.5;
      }
    `,
  ],
  imports: [],
})
export class AgGridDateComponent implements IDateAngularComp {
  @ViewChild('textInput') private readonly textInput: ElementRef<HTMLInputElement>;
  @ViewChild('nativePicker') private readonly nativePicker: ElementRef<HTMLInputElement>;

  public displayValue = '';
  public placeholder = 'DD.MM.YYYY';
  public disabled = false;
  public ariaLabel = '';

  private date: Date | null = null;
  private params: IDateParams;

  public agInit(params: IDateParams): void {
    this.params = params;
  }

  public getDate(): Date | null {
    return this.date;
  }

  public setDate(date: Date | null): void {
    this.date = date;
    this.displayValue = date ? moment(date).locale('de').format('L') : '';
  }

  public refresh(params: IDateParams): void {
    this.params = params;
  }

  public setDisabled(disabled: boolean): void {
    this.disabled = disabled;
  }

  public setInputPlaceholder(placeholder: string): void {
    this.placeholder = placeholder;
  }

  public setInputAriaLabel(label: string): void {
    this.ariaLabel = label;
  }

  public afterGuiAttached(): void {
    this.textInput?.nativeElement?.focus({ preventScroll: true });
  }

  public onTextInput(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    this.displayValue = value;
    const parsed = moment(value, 'DD.MM.YYYY', true);
    this.date = parsed.isValid() ? parsed.toDate() : null;
    this.params.onDateChanged();
  }

  public onNativeDateChange(event: Event): void {
    const isoValue = (event.target as HTMLInputElement).value;
    if (isoValue) {
      const parsed = new Date(`${isoValue}T00:00:00`);
      this.date = parsed;
      this.displayValue = moment(parsed).locale('de').format('L');
    } else {
      this.date = null;
      this.displayValue = '';
    }
    this.params.onDateChanged();
  }

  public openCalendar(): void {
    this.nativePicker?.nativeElement?.showPicker();
  }
}
